// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordUserDetailsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsLandlordUserDetailsWebApiHandler_details,
  CappsLandlordUserDetailsWebApiHandler_details_Path,
} from '@zg-rentals/ts-capps-client';

import type { LandlordUserDetailsResponseDto } from '@zg-rentals/ts-capps-client';

export type CappsLandlordUserDetailsWebApiHandler_details_Options = UseQueryOptions<
  LandlordUserDetailsResponseDto,
  unknown,
  LandlordUserDetailsResponseDto,
  readonly [string]
>;

const CappsLandlordUserDetailsWebApiHandler_details_GetKey = () =>
  [CappsLandlordUserDetailsWebApiHandler_details_Path] as const;

export const CappsLandlordUserDetailsWebApiHandler_details_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsLandlordUserDetailsWebApiHandler_details_GetKey(),
    queryFn: () => CappsLandlordUserDetailsWebApiHandler_details(httpClient),
  }) as const satisfies QueryOptions;

export const useCappsLandlordUserDetailsWebApiHandler_details = ({
  httpClient,
  ...options
}: Omit<CappsLandlordUserDetailsWebApiHandler_details_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...CappsLandlordUserDetailsWebApiHandler_details_queryOptions({ httpClient }),
    ...options,
  });
};
useCappsLandlordUserDetailsWebApiHandler_details.getKey = CappsLandlordUserDetailsWebApiHandler_details_GetKey;
